// @flow
import React from 'react';
import { Box, Button } from 'grommet';
import { Close } from 'grommet-icons';

const RemoveRowButton = ({ onClick }: { onClick: Function }) => {
    const pointsEndRef: { current: null | React.ElementRef<Box> } = React.useRef(null);

    React.useEffect(() => {
        if (pointsEndRef.current) {
            pointsEndRef.current.scrollIntoView();
        }
    }, []);

    return (
        <Button
            ref={pointsEndRef}
            alignSelf="end"
            icon={<Close />}
            onClick={onClick}
        />
    );
};

export default RemoveRowButton;
